<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <confirmPopup
      v-if="popuplessonDelete == true"
      :title="titlepass"
      @cancelClick="popuplessonDelete = false"
      @confirmClick="deleteLesson(idpass)"
    />
    <confirmPopup
      v-if="popupsectionDelete == true"
      :title="titlepass"
      @cancelClick="popupsectionDelete = false"
      @confirmClick="deleteSection(idpass)"
    />

    <confirmPopup
      v-if="popupwindowquestiondelete != null"
      :title="titlepass"
      @cancelClick="popupwindowquestiondelete = null"
      @confirmClick="removeQuestion(popupwindowquestiondelete)"
    />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <div
            class="rounded-3xl pt-10 px-4 md:px-10 pb-2 heightfix bg-white overflow-y-auto"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex justify-start mb-4">
              <div class="flex items-center justify-end gap-4">
                <!-- <button
                  @click="triggerAddUNitClose"
                  class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full cursor-pointer"
                >
                  Close
                </button> -->

                <router-link
                  :to="{
                    name: 'HodCourses',
                    params: { semester: this.semester, batch: this.batch },
                  }"
                  class="bg-blues text-xs font-bold text-white hover:bg-hover hover:text-white px-5 py-1.5 rounded-full"
                  >Back</router-link
                >

                <!-- <router-link
                  :to="{
                    name: 'AdminCoursePreview',
                    params: { course_id: this.course_id },
                  }"
                  class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                >
                  Preview
                </router-link> -->

                <!-- 
                  <router-link
                    :to="{
                      name: 'InstructorCoursePreview',
                      params: { courseid: this.course_id },
                    }"
                    class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
                    >Preview</router-link
                  > -->
              </div>
            </div>

            <div class="flex items-center justify-center">
              <!-- <div class="hidden lg:flex"></div> -->
              <div>
                <h1 class="py-2 text-xl text-center font-bold text-textblues">
                  Update Course
                </h1>
              </div>
            </div>

            <div
              class="mt-10 flex items-center justify-center rounded-lg cursor-pointer gap-2 px-4 py-5 border border-blues hover:bg-gray-100"
              @click="popUpsection = true"
            >
              <img src="@/assets/newd/icon1.svg" alt />
              <p class="text-textblues text-sm">Add Module</p>
            </div>
            <div
              v-if="loading"
              class="flex items-center justify-center h-[calc(100vh-350px)]"
            >
              <img src="@/assets/newd/loading.gif" alt="Loading" />
            </div>
            <!-- unit loop section  -->
            <div v-else class="mt-10 pb-10 flex flex-col gap-10">
              <div v-for="section in sectionInfo.data" class :key="section">
                <div
                  class="flex items-center justify-between border border-blues hover:bg-gray-100 rounded-lg px-6 py-5 cursor-pointer"
                  @click="courseSectionToggle(section.id)"
                >
                  <h1
                    class="text-textblues font-semibold w-[80%] md:w-auto flex gap-3"
                  >
                    <p v-if="section.file_type == 'video'">🎥</p>
                    <p v-if="section.file_type == 'download'">⬇️</p>
                    <p v-if="section.file_type == 'document'">📄</p>
                    <p v-if="section.file_type == 'pdf'">📕</p>
                    <p v-if="section.file_type == 'word'">📘</p>
                    <p v-if="section.file_type == 'general'">⚫</p>
                    {{ section.title.slice(0, 100) }}
                    <p
                      v-if="section.title.length > 100"
                      class="text-textblues text-sm mt-1 font-semibold"
                    >
                      ...More
                    </p>
                  </h1>

                  <div class="relative dropdown-container">
                    <div
                      @click="addOperation(section.id)"
                      class="cursor-pointer"
                    >
                      <img
                        src="@/assets/more.png"
                        class="w-10 h-10 md:w-6 md:h-6 object-contain cursor-pointer"
                        alt
                      />
                    </div>
                    <div
                      v-if="activeOperationMenu == section.id"
                      class="absolute top-10 w-[150px] z-30 bg-white rounded-xl shadow-lg right-0 py-1"
                      style="box-shadow: 0px 2px 20px 0px #00000040"
                    >
                      <div
                        class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                        @click="
                          (popUpLesson = true), (selectUnitId = section.id)
                        "
                      >
                        <img src="@/assets/newd/icon1.svg" class="w-5" alt />
                        <p class="text-textblues text-sm">Add Lesson</p>
                      </div>

                      <div
                        class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                        @click="(popUpQuiz = true), (selectUnitId = section.id)"
                      >
                        <img src="@/assets/newd/icon1.svg" class="w-5" alt />
                        <p class="text-textblues text-sm">Add Quiz</p>
                      </div>

                      <div
                        class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                        @click="
                          sectionval = section;
                          popUpsectionUpdate = true;
                        "
                      >
                        <img src="@/assets/newd/icon2.svg" class="w-5" alt />
                        <p class="text-greens text-sm">Edit</p>
                      </div>
                      <div
                        class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                        @click="
                          titlepass = section.title;
                          popupsectionDelete = true;
                          idpass = section.id;
                        "
                      >
                        <img src="@/assets/newd/icon3.svg" class="w-5" alt />
                        <p class="text-[#F36540] text-sm">Delete</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- lessonInfo != null -->
                <div
                  v-if="
                    activeCourseMenu === section.id &&
                    lessonsBySection[section.id]
                  "
                >
                  <draggable
                    class="dragArea list-group w-full"
                    :list="lessonsBySection[section.id]"
                    :group="'lessons'"
                    @change="(evt) => onReorder(section.id, evt)"
                  >
                    <div
                      v-for="lesson in lessonsBySection[section.id]"
                      :key="lesson.id"
                    >
                      <div
                        v-if="section.id == lesson.section_id"
                        class="bg-blues hover:bg-[#3aa0dd] rounded-lg my-3 justify-between relative dropdown-container group"
                      >
                        <div
                          @click="addLessonOperation(lesson.id)"
                          class="px-6 py-5 flex items-center justify-between"
                        >
                          <div class="flex gap-3 items-center">
                            <!-- 3x3 Dots Icon -->
                            <div
                              class="hidden md:block w-[15px] h-[18px] flex justify-center mx-auto"
                            >
                              <div
                                class="hidden group-hover:inline-flex items-center justify-center rounded cursor-pointer"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                  class="w-5 h-5 text-white"
                                >
                                  <circle cx="5" cy="5" r="1.5" />
                                  <circle cx="12" cy="5" r="1.5" />
                                  <circle cx="5" cy="12" r="1.5" />
                                  <circle cx="12" cy="12" r="1.5" />

                                  <circle cx="5" cy="19" r="1.5" />
                                  <circle cx="12" cy="19" r="1.5" />
                                </svg>
                              </div>
                            </div>

                            <p v-if="lesson.file_type == 'video'">🎥</p>
                            <p v-if="lesson.file_type == 'download'">⬇️</p>
                            <p v-if="lesson.file_type == 'document'">📄</p>
                            <p v-if="lesson.file_type == 'pdf'">📕</p>
                            <p v-if="lesson.file_type == 'word'">📘</p>
                            <p v-if="lesson.file_type == 'general'">⚫</p>

                            <p class="text-sm font-semibold text-white">
                              {{ lesson.title }}
                            </p>
                          </div>

                          <img
                            src="@/assets/newd/3dot.png"
                            alt
                            class="px-4 cursor-pointer"
                          />
                        </div>

                        <div
                          v-if="activeLessonOperationMenu == lesson.id"
                          class="absolute top-10 w-[150px] z-30 bg-white rounded-xl shadow-lg right-0 py-1"
                          style="box-shadow: 0px 2px 20px 0px #00000040"
                        >
                          <div
                            v-if="lesson.lesson_or_quiz == 'lesson'"
                            class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                            @click="
                              updateVale(lesson);
                              lessonVal = lesson;
                              popUp = true;
                              descriptionUpdate = lesson.content;
                            "
                          >
                            <img
                              src="@/assets/newd/icon2.svg"
                              class="w-5"
                              alt
                            />
                            <p class="text-greens text-sm">Edit Lesson</p>
                          </div>

                          <div
                            v-if="lesson.lesson_or_quiz == 'quiz'"
                            class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                            @click="
                              getupdateValues(lesson.quizzes[0].quiz.id);
                              popUpupdateQuiz = true;
                            "
                          >
                            <img
                              src="@/assets/newd/icon2.svg"
                              class="w-5"
                              alt
                            />
                            <p class="text-greens text-sm">Edit Quiz</p>
                          </div>

                          <!-- <p v-if="lesson.quizzes.length == 0" class="text-black">Lesson</p>
                        <p v-if="lesson.quizzes.length != 0" class="text-black">Quiz</p> -->

                          <div
                            class="flex items-center gap-2 px-4 py-2 cursor-pointer"
                            @click="
                              titlepass = lesson.title;
                              popuplessonDelete = true;
                              idpass = lesson.id;
                            "
                          >
                            <img
                              src="@/assets/newd/icon3.svg"
                              class="w-5"
                              alt
                            />
                            <p class="text-[#F36540] text-sm">Delete</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- update unit  -->
    <div
      v-if="popUpsectionUpdate"
      @click.self="popUpsectionUpdate = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center p-4"
    >
      <div
        class="w-full max-w-lg sm:max-w-md md:max-w-lg lg:max-w-xl bg-white rounded-xl p-6 sm:p-8 md:p-10 overflow-y-auto max-h-[80vh]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg sm:text-xl font-bold text-textblues">Update Module</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUpsectionUpdate = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 sm:p-6 relative border border-gray-100 rounded-2xl"
        >
          <form
            ref="addSection"
            @submit.prevent="updatesection(sectionval)"
            class="flex flex-col gap-4 text-xs sm:text-sm md:text-base h-full"
          >
            <div class="flex flex-col gap-2 w-full">
              <label for="title" class="text-left flex gap-2 items-center"
                >Title <span class="text-red-500">*</span></label
              >
              <input
                id="title"
                v-model="sectionval.title"
                type="text"
                class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                required
              />
            </div>
            <!-- <div class="flex flex-col gap-2 w-full">
                  <label for="rbt_levels" class="text-left flex gap-2 items-center">RBT Levels <span class="text-red-500">*</span></label>
                  <input
                    id="rbt_levels"
                    type="text"
                    v-model="sectionval.rbt_levels"
                    class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    required
                  />
                </div> -->

            <!-- <div class="flex flex-col gap-2 w-full hidden">
              <label for="duration" class="text-left flex gap-2 items-center"
                >Duration <span class="text-red-500">*</span></label
              >
              <input
                id="duration"
                type="text"
                v-model="sectionval.duration"
                class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div> -->
            <div class="flex flex-col gap-3">
              <label for="icon" class="text-sm">Icon </label>
              <select
                name="icon"
                id="icon"
                class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                v-model="sectionval.file_type"
              >
                <option value="" selected>Select</option>
                <option value="video">video 🎥</option>
                <option value="download">download ⬇️</option>
                <option value="document">document 📄</option>
                <option value="pdf">pdf 📕</option>
                <option value="word">word 📘</option>
                <option value="general">general ⚫</option>
              </select>
            </div>
            <div class="flex justify-end items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-hover cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-6 py-2"
              >
                Update
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
            <!-- <div class="flex justify-end pb-4 mt-3">
              <button
                type="submit"
                class="text-white border border-blues rounded-lg text-sm px-10 py-2 bg-blues"
              >
                Update
              </button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
    <!-- add unit  -->
    <div
      v-if="popUpsection"
      @click.self="popUpsection = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full sm:w-[90%] md:w-[70%] lg:w-[40%] bg-white rounded-xl p-6 sm:p-8 md:p-10 overflow-y-auto max-h-[600px]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-xl font-bold text-textblues">Add Module</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer"
            alt
            @click="popUpsection = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 sm:p-6 relative border border-gray-100 rounded-2xl"
        >
          <div class="w-full">
            <form
              ref="addSection"
              @submit.prevent="createNewsection"
              class="flex flex-col gap-4 text-xs sm:text-sm md:text-base h-full"
            >
              <div class="flex flex-col gap-2 w-full">
                <label for="title" class="text-left flex gap-2 items-center"
                  >Title :<span class="text-red-500">*</span></label
                >
                <input
                  id="title"
                  type="text"
                  class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  required
                />
              </div>

              <!-- <div class="flex flex-col gap-2 w-full">
                  <label for="rbt_levels" class="text-left flex gap-2 items-center">RBT Levels <span class="text-red-500">*</span></label>
                  <input
                    id="rbt_levels"
                    type="text"
                    class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    required
                  />
                </div> -->

              <div class="flex flex-col gap-2 w-full hidden">
                <label for="duration" class="text-left flex gap-2 items-center"
                  >Duration :<span class="text-red-500">*</span>
                  <div class="relative group">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <div
                      class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                    >
                      provide a Mints
                    </div>
                  </div>
                </label>
                <input
                  id="duration"
                  type="text"
                  class="border border-gray-300 rounded text-xs sm:text-sm md:text-base py-2 px-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <div class="flex flex-col gap-3">
                <label for="icon" class="text-sm">Icon :</label>
                <select
                  name="icon"
                  id="icon"
                  class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                >
                  <option value="" selected>Select</option>
                  <option value="video">video 🎥</option>
                  <option value="download">download ⬇️</option>
                  <option value="document">document 📄</option>
                  <option value="pdf">pdf 📕</option>
                  <option value="word">word 📘</option>
                  <option value="general">general ⚫</option>
                </select>
              </div>
              <div class="flex justify-end items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-hover cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-6 py-2"
                >
                  Submit
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
              <!-- <div class="flex justify-end pb-4 mt-3">
                <button
                  type="submit"
                  class="text-black border border-black rounded-lg text-sm px-6 sm:px-8 md:px-10 py-2 hover:bg-black hover:text-white transition duration-300"
                >
                  Submit
                </button>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- update lesson  -->
    <div
      v-if="popUp"
      @click.self="popUp = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full max-w-4xl bg-white rounded-xl p-6 md:p-10 overflow-y-auto h-[95%]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-bold text-textblues">Update Lesson</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUp = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 md:p-6 border border-gray-100 rounded-2xl"
        >
          <form ref="lessonaddFn" @submit.prevent="updateLesson">
            <div class="py-6 flex flex-col gap-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
                <div class="flex flex-col gap-3">
                  <label for="title" class="text-sm"
                    >Title <span class="text-red-400">*</span></label
                  >
                  <input
                    id="title"
                    type="text"
                    v-model="lessonVal.title"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="duration" class="text-sm"
                    >Duration <span class="text-red-400">*</span></label
                  >
                  <input
                    id="duration"
                    type="number"
                    v-model="lessonVal.duration"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
              </div>

              <div class="flex flex-col gap-3">
                <label for="section" class="text-sm">Module</label>
                <select
                  name="section"
                  id="section"
                  class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                  v-model="lessonVal.section_id"
                >
                  <option
                    v-for="section in sectionInfo.data"
                    :key="section.id"
                    :value="section.id"
                  >
                    {{ section.title }}
                  </option>
                </select>
              </div>

              <div class="w-full">
                <form
                  enctype="multipart/form-data"
                  class="flex flex-col gap-4 w-full"
                  method="POST"
                  @submit.prevent="
                    uploadFilebyChunkNew('fileuploadUpdate', 'getVideoU')
                  "
                >
                  <div class="flex flex-col gap-3">
                    <label class="font-bold text-sm"
                      >Select video file to upload.</label
                    >
                    <input
                      type="file"
                      class="form-control bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="fileuploadUpdate"
                      @change="CheckVideoSizeUpload"
                      accept="video/*"
                      required
                    />
                  </div>
                  <p v-if="video_error" style="color: red">{{ video_error }}</p>
                  <div class="flex items-center gap-3 justify-end">
                    <input
                      type="submit"
                      value="Upload"
                      :disabled="disable_update == true"
                      id="submit"
                      :class="
                        this.disable_update == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-6 py-2"
                    />
                    <img
                      v-if="disable_update"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
                <div id="statusCode" class="mt-2 text-sm text-gray-600"></div>
              </div>

              <div class="flex flex-col gap-3">
                <label for="getVideoU" class="text-sm">Video URL</label>
                <input
                  type="text"
                  @mouseleave="convertToEmbed('getVideoU')"
                  id="getVideoU"
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                />
              </div>

              <!-- show_polls -->

              <div class="flex flex-row gap-4 gap-3">
                <input
                  id="show_polls"
                  v-model="lessonVal.show_polls"
                  type="checkbox"
                  class="cursor-pointer"
                />
                <label for="show_polls" class="text-sm font-medium">
                  Show Student Polls Count
                </label>
              </div>

              <div class="flex flex-row gap-4 gap-3">
                <input
                  id="poll_attempt"
                  v-model="lessonVal.polls"
                  type="checkbox"
                  class="cursor-pointer"
                />
                <label for="poll_attempt" class="text-sm font-medium">
                  Enable Polls
                </label>
              </div>
              <div v-if="lessonVal.polls">
                <div
                  class="flex flex-col gap-3 w-full"
                  v-if="lessonVal.poll_details != null"
                >
                  <label for="poll_question" class="text-sm font-medium">
                    Poll Question <span class="text-red-400">*</span>
                  </label>
                  <input
                    id="poll_question"
                    type="text"
                    placeholder="Enter Question"
                    required
                    v-model="lessonVal.poll_details.question"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                  />
                  <div
                    v-for="(poll, index) in lessonVal?.poll_details?.options"
                    :key="index"
                  >
                    <div
                      class="w-full flex items-center bg-gray-100 border rounded-lg gap-3"
                    >
                      <input
                        type="text"
                        v-model="poll.text"
                        :placeholder="`Enter Choice  ${index + 1}`"
                        class="text-sm w-full bg-gray-100 p-3 outline-none"
                      />
                      <div class="flex items-center gap-3 px-3">
                        <img
                          v-if="index > 0"
                          @click="editAddRow(lessonVal?.poll_details?.options)"
                          src="@/assets/plus.png"
                          alt="add"
                          class="w-6 h-6 object-contain cursor-pointer hidden"
                        />
                        <img
                          v-if="index > 1"
                          @click="
                            editRemoveRow(
                              lessonVal?.poll_details?.options,
                              index
                            )
                          "
                          src="@/assets/remove.png"
                          alt="add"
                          class="w-6 h-6 object-contain cursor-pointer hidden"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="flex flex-col gap-3 w-full"
                  v-if="lessonVal.poll_details == null"
                >
                  <label for="poll_question" class="text-sm font-medium">
                    Poll Question <span class="text-red-400">*</span>
                  </label>
                  <input
                    id="poll_question"
                    type="text"
                    placeholder="Enter Question"
                    required
                    v-model="polls_data.question"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                  />
                  <div v-for="(poll, index) in polls_data.options" :key="index">
                    <div
                      class="w-full flex items-center bg-gray-100 border rounded-lg gap-3"
                    >
                      <input
                        type="text"
                        v-model="poll.text"
                        :placeholder="`Enter Choice  ${index + 1}`"
                        class="text-sm w-full bg-gray-100 p-3 outline-none"
                      />
                      <div class="flex items-center gap-3 px-3">
                        <img
                          v-if="index > 0"
                          @click="addRow"
                          src="@/assets/plus.png"
                          alt="add"
                          class="w-6 h-6 object-contain cursor-pointer"
                        />
                        <img
                          v-if="index > 1"
                          @click="removeRow(index)"
                          src="@/assets/remove.png"
                          alt="add"
                          class="w-6 h-6 object-contain cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col gap-3">
                <label class="text-sm"
                  >Description <span class="text-red-400">*</span></label
                >
                <QuillEditor
                  theme="snow"
                  class="border rounded-2xl min-h-[200px]"
                  toolbar="full"
                  :content="descriptionUpdate"
                  contentType="html"
                />
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
                <div class="flex flex-col gap-3">
                  <label class="text-sm">Keywords </label>
                  <input
                    type="text"
                    v-model="lessonVal.keyworeds"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label class="text-sm"
                    >Order By <span class="text-red-400">*</span></label
                  >
                  <input
                    type="number"
                    v-model="lessonVal.orderby"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
              </div>
              <div class="flex flex-col gap-3">
                <label for="icon" class="text-sm">Icon </label>
                <select
                  name="icon"
                  id="icon"
                  class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                  v-model="lessonVal.file_type"
                >
                  <option value="" selected>Select</option>
                  <option value="video">video 🎥</option>
                  <option value="download">download ⬇️</option>
                  <option value="document">document 📄</option>
                  <option value="pdf">pdf 📕</option>
                  <option value="word">word 📘</option>
                  <option value="general">general ⚫</option>
                </select>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
                <div class="flex flex-col gap-3">
                  <label class="text-sm">PDF File</label>
                  <input
                    id="pdf_files"
                    type="file"
                    accept=".pdf"
                    @change="CheckPdfSizeUpload"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <p v-if="pdf_error" style="color: red">{{ pdf_error }}</p>
                  <a
                    :href="lessonVal.pdf_file"
                    class="text-textblues text-xs font-semibold"
                    >View PDF</a
                  >
                </div>

                <div class="flex flex-col gap-3">
                  <label class="text-sm">Audio File</label>
                  <input
                    id="audiofile"
                    type="file"
                    accept="audio/*"
                    @change="CheckAudioSizeUpload"
                    class="bg-gray-100 rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <p v-if="audio_error" style="color: red">{{ audio_error }}</p>
                  <audio
                    controls
                    v-if="lessonVal.audio_file"
                    class="rounded-xl"
                  >
                    <source :src="lessonVal.audio_file" type="audio/ogg" />
                    <source :src="lessonVal.audio_file" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>

              <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-2">
                  <label for="showing_timer" class="text-sm"
                    >Time<span class="text-red-400">*</span></label
                  >
                  <input
                    v-model="lessonVal.showing_timer"
                    type="number"
                    maxlength="99"
                    minlength="1"
                    required
                    class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                  />
                </div>
              </div> -->

              <div class="flex justify-end items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-hover cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-6 py-2"
                >
                  Update
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Add Lesson  -->
    <div
      v-if="popUpLesson"
      @click.self="popUpLesson = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full md:w-[80%] lg:w-[60%] bg-white rounded-xl p-6 md:p-10 overflow-y-auto h-[90%]"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <h3
              class="text-base font-bold px-4 py-1 rounded-xl cursor-pointer text-textblues"
            >
              Add Lessons
            </h3>
          </div>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt="Close"
            @click="popUpLesson = false"
          />
        </div>
        <div class="w-full mt-4 p-4 md:p-6 border border-gray-100 rounded-2xl">
          <form
            ref="lessonaddFnadd"
            @submit.prevent="createNewLesson"
            class="space-y-6"
          >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="flex flex-col gap-2">
                <label for="title" class="text-sm"
                  >Title <span class="text-red-400">*</span></label
                >
                <input
                  id="title"
                  type="text"
                  required
                  class="bg-gray-100 rounded-lg text-sm p-3 border-none outline-none"
                />
              </div>
              <div class="flex flex-col gap-2">
                <label for="duration" class="text-sm"
                  >Duration <span class="text-red-400">*</span></label
                >
                <input
                  id="duration"
                  type="number"
                  required
                  class="bg-gray-100 rounded-lg text-sm p-3 border-none outline-none"
                />
              </div>
            </div>

            <div class="w-full">
              <form
                enctype="multipart/form-data"
                class="flex flex-col gap-4"
                method="POST"
                @submit.prevent="
                  uploadFilebyChunkNew('fileupload', 'videoUrlNew')
                "
              >
                <div class="flex flex-col gap-2">
                  <label class="font-bold text-sm"
                    >Select video file to upload.</label
                  >
                  <input
                    type="file"
                    class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                    id="fileupload"
                    @change="CheckVideoSizeUpload"
                    accept="video/*"
                    required
                  />
                </div>
                <p v-if="video_error" style="color: red">{{ video_error }}</p>
                <div class="flex items-center gap-3 justify-end">
                  <!-- <button type="submit">Upload</button> -->
                  <input
                    type="submit"
                    value="Upload"
                    id="submit"
                    :class="
                      this.disable_update == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-hover cursor-pointer text-white'
                    "
                    class="rounded-lg text-sm px-6 py-2"
                  />
                  <img
                    v-if="disable_update"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </form>
              <div id="uploaded_files" class="mt-2"></div>
              <div id="statusCode"></div>
            </div>

            <div class="flex flex-col gap-2">
              <label for="videoUrl" class="text-sm">Video URL</label>
              <input
                id="videoUrlNew"
                type="text"
                @mouseleave="convertToEmbed('videoUrlNew')"
                class="bg-gray-100 rounded-lg p-3 border-none outline-none"
              />
            </div>

            <div class="flex flex-row gap-3">
              <input id="show_polls" type="checkbox" />
              <label for="show_polls" class="text-sm font-medium">
                Show Student Polls Count
              </label>
            </div>

            <div class="flex flex-row gap-4 gap-3">
              <input
                id="poll_attempt"
                type="checkbox"
                @change="havePolls('poll_attempt')"
              />
              <label for="poll_attempt" class="text-sm font-medium">
                Enable Polls
              </label>
            </div>
            <div v-if="check_polls">
              <div class="flex flex-col gap-3 w-full">
                <label for="poll_question" class="text-sm font-medium">
                  Poll Question <span class="text-red-400">*</span>
                </label>
                <input
                  id="poll_question"
                  type="text"
                  placeholder="Enter Question"
                  required
                  v-model="polls_data.question"
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
                <div v-for="(poll, index) in polls_data.options" :key="index">
                  <div
                    class="w-full flex items-center bg-gray-100 border rounded-lg gap-3"
                  >
                    <input
                      type="text"
                      v-model="poll.text"
                      :placeholder="`Enter Choice  ${index + 1}`"
                      class="text-sm w-full bg-gray-100 p-3 outline-none"
                    />
                    <div class="flex items-center gap-3 px-3">
                      <img
                        v-if="index > 0"
                        @click="addRow"
                        src="@/assets/plus.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer"
                      />
                      <img
                        v-if="index > 1"
                        @click="removeRow(index)"
                        src="@/assets/remove.png"
                        alt="add"
                        class="w-6 h-6 object-contain cursor-pointer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <label class="text-sm"
                >Description <span class="text-red-400">*</span></label
              >
              <QuillEditor
                class="border rounded-2xl h-48"
                toolbar="full"
                :content="description"
                contentType="html"
              />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="flex flex-col gap-2">
                <label for="keywords" class="text-sm">Keywords</label>
                <input
                  id="keywords"
                  type="text"
                  class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                />
              </div>
              <div class="flex flex-col gap-2">
                <label for="orderby" class="text-sm"
                  >Order By <span class="text-red-400">*</span></label
                >
                <input
                  id="orderby"
                  type="number"
                  required
                  class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                />
              </div>

              <div class="flex flex-col gap-3">
                <label for="icon" class="text-sm">Icon :</label>
                <select
                  name="icon"
                  id="icon"
                  class="bg-gray-50 border-gray-300 rounded-md p-3 w-full"
                >
                  <option value="" selected>Select</option>
                  <option value="video">video 🎥</option>
                  <option value="download">download ⬇️</option>
                  <option value="document">document 📄</option>
                  <option value="pdf">pdf 📕</option>
                  <option value="word">word 📘</option>
                </select>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="flex flex-col gap-2">
                <label for="pdffile" class="text-sm">PDF File</label>
                <input
                  id="pdffile"
                  type="file"
                  accept=".pdf"
                  @change="CheckPdfSizeUpload"
                  class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                />
                <p v-if="pdf_error" style="color: red">{{ pdf_error }}</p>
              </div>
              <div class="flex flex-col gap-2">
                <label for="audio_file" class="text-sm">Audio File</label>
                <input
                  id="audio_file"
                  type="file"
                  accept="audio/*"
                  @change="CheckAudioSizeUpload"
                  class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                />
                <p v-if="audio_error" style="color: red">{{ audio_error }}</p>
              </div>
            </div>
            <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="flex flex-col gap-2">
                <label for="showing_timer" class="text-sm"
                  >Time<span class="text-red-400">*</span></label
                >
                <input
                  id="showing_timer"
                  type="number"
                  maxlength="99"
                  minlength="1"
                  required
                  class="bg-gray-100 rounded-lg p-3 border-none outline-none"
                />
              </div>
            </div> -->
            <div class="flex justify-end items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-hover cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-6 py-2"
              >
                Save
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Add Quiz -->
    <div
      v-if="popUpQuiz"
      @click.self="popUpQuiz = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full md:w-[80%] lg:w-[60%] bg-white rounded-xl p-3 md:p-10 overflow-y-auto h-[90%]"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <h3
              class="text-base font-bold px-4 py-1 rounded-xl cursor-pointer text-textblues"
            >
              Add Quiz
            </h3>
          </div>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt="Close"
            @click="popUpQuiz = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col md:p-6 relative border border-gray-100 rounded-2xl"
        >
          <form
            ref="addQuizRefs"
            @submit.prevent="createQuizOfSection"
            class="w-full flex flex-col gap-3"
          >
            <div class="flex flex-col gap-3 w-full">
              <label for="title" class="text-sm font-medium">
                Title <span class="text-red-400">*</span>
              </label>
              <input
                id="title"
                type="text"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div>

            <div class="flex flex-col gap-3 w-full">
              <label for="content" class="text-sm font-medium">
                Content <span class="text-red-400">*</span>
              </label>
              <input
                id="content"
                type="text"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div>

            <!-- lesson_or_quiz -->

            <div class="flex flex-row gap-4">
              <input
                id="question_attempt"
                type="checkbox"
                @change="haveAttempt('question_attempt')"
              />
              <label for="question_attempt" class="text-sm font-medium">
                Mutiple Attempt
              </label>
            </div>

            <div class="flex flex-col gap-3 w-full" v-if="checkedAttempt">
              <label for="question_attempt_count" class="text-sm font-medium">
                Attempt Count <span class="text-red-400">*</span>
              </label>
              <input
                id="question_attempt_count"
                type="number"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                max="100"
              />
            </div>

            <div class="flex flex-col gap-3 w-full">
              <label for="order" class="text-sm font-medium">
                Order By <span class="text-red-400">*</span>
              </label>
              <input
                id="order"
                type="number"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div>

            <!-- <div class="flex items-center gap-2">
                  <input type="radio" name="selectOption" id="" value="choice" v-model="choiceType"> Choice Type
                  <input type="radio" name="selectOption" id="" value="short" v-model="choiceType"> Short Answer
                  <input type="radio" name="selectOption" id="" value="long" v-model="choiceType"> Long Answer
                </div> -->

            <div class="flex flex-col gap-5">
              <div
                v-for="(form, index) in forms"
                :key="index"
                class="w-full mt-3 bg-gray-200 rounded-lg lg:p-4"
              >
                <div class="flex flex-col gap-5">
                  <div
                    class="flex items-center justify-between bg-primary px-4 py-2 md:px-6 md:py-3 rounded-t-lg w-full"
                  >
                    <label class="text-lg text-white"
                      >Question {{ index + 1 }}:</label
                    >
                    <button
                      v-if="index != 0"
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="removeForm(index)"
                    >
                      Remove Question
                    </button>
                  </div>

                  <div class="px-4 sm:px-6 py-2">
                    <textarea
                      v-model="form.question_text"
                      rows="2"
                      required
                      class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                      placeholder="Enter your question"
                    >
                    </textarea>
                  </div>
                </div>

                <div
                  class="flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4 px-4 sm:px-6 py-2"
                >
                  <!-- <div>
                    <input
                      type="radio"
                      value="choice"
                      v-model="form.choice_type"
                    />
                    Choice Type
                  </div>
                  <div>
                    <input
                      type="radio"
                      value="truefalse"
                      v-model="form.choice_type"
                    />
                    True or False
                  </div>
                  <div>
                    <input
                      type="radio"
                      value="matchthefollowing"
                      v-model="form.choice_type"
                    />
                    Match the following
                  </div>
                  <div>
                    <input
                      type="radio"
                      value="shortdescription"
                      v-model="form.choice_type"
                    />
                    Short Answer
                  </div>
                  <div>
                    <input
                      type="radio"
                      value="description"
                      v-model="form.choice_type"
                    />
                    Long Answer
                  </div> -->
                </div>

                <!-- {{ form.choiceType }} -->
                <div
                  v-if="form.choice_type == 'matchthefollowing'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <input
                      type="text"
                      v-model="address['left_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Left Option"
                      required
                    />
                    <input
                      type="text"
                      v-model="address['right_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Right Option"
                      required
                    />

                    <button
                      type="button"
                      class="bg-red-500 rounded-lg rounded-lg text-white text-xs px-2 py-1"
                      @click="removeMatchtheFollowing(index)"
                    >
                      remove
                    </button>
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <!-- <label class="text-sm">Is Answer</label> -->
                  </div>

                  <button
                    type="button"
                    @click="addMoreMatchtheFollowing(index)"
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'truefalse'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.truefalse"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <label class="text-sm text-gray-700"> </label>
                    <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <label class="text-sm"
                      ><span v-if="addrIndex == 0">True</span>
                      <span v-else>False</span></label
                    >
                  </div>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'choice'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.answers"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    >
                    <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    />
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <label class="text-sm">Is Answer</label>

                    <button
                      type="button"
                      class="bg-red-500 rounded-lg rounded-lg text-white text-xs px-2 py-1"
                      @click="removeChoiceType(index)"
                    >
                      remove
                    </button>
                  </div>

                  <button
                    type="button"
                    @click="addMoreChoiceType(index)"
                    class="bg-blues text-sm text-white rounded-md px-4 py-2"
                  >
                    Add More
                  </button>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'shortdescription'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="3"
                    v-model="form.shortAnswerMark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'description'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="10"
                    v-model="form.longAnswerMark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    placeholder="Add Mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                  />
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-4 mt-4">
              <button
                type="button"
                @click="addForm"
                class="bg-blues text-sm text-white rounded-md px-4 py-2"
              >
                Add Question
              </button>
              <div class="flex items-center gap-3">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-hover cursor-pointer text-white'
                  "
                  class="rounded-lg text-sm px-4 py-2"
                >
                  Save
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Update Quiz -->
    <div
      v-if="popUpupdateQuiz"
      @click.self="popUpupdateQuiz = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
    >
      <div
        class="w-full max-w-4xl bg-white rounded-xl p-6 md:p-10 overflow-y-auto h-[95%]"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-bold text-textblues">Update Quiz</h3>
          <img
            src="@/assets/newd/close.png"
            class="cursor-pointer w-5 h-5"
            alt
            @click="popUpupdateQuiz = false"
          />
        </div>

        <div
          class="w-full mt-4 flex flex-col p-4 md:p-6 border border-gray-100 rounded-2xl"
        >
          <!-- {{ currentQuizData }} -->

          <form
            ref="addQuizRefs"
            @submit.prevent="updateQuizOfSection(currentQuizData.id)"
            class="w-full flex flex-col gap-3"
          >
            <div class="flex flex-col gap-5">
              <!-- <div class="flex items-center justify-end mt-3">
                <button
                  @click="addForm"
                  class="bg-blues text-sm text-white rounded-md px-4 py-2"
                >
                  Add Question
                </button>
              </div> -->
              <div class="flex flex-col gap-3 w-full">
                <label for="title" class="text-sm font-medium">
                  Title <span class="text-red-400">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  v-model="currentQuizData.lesson_title"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="content" class="text-sm font-medium">
                  Content <span class="text-red-400">*</span>
                </label>
                <input
                  id="content"
                  type="text"
                  v-model="currentQuizData.lesson_content"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <div class="flex flex-row gap-3">
                <input
                  id="question_attempt_update"
                  v-model="currentQuizData.question_attempt"
                  :checked="currentQuizData.question_attempt"
                  type="checkbox"
                />
                <label for="question_attempt" class="text-sm font-medium">
                  Mutiple Attempt
                </label>
              </div>

              <div
                class="flex flex-col gap-3 w-full"
                v-if="currentQuizData.question_attempt"
              >
                <label for="question_attempt_count" class="text-sm font-medium">
                  Attempt Count <span class="text-red-400">*</span>
                </label>
                <input
                  id="question_attempt_count_update"
                  v-model="currentQuizData.question_attempt_count"
                  type="number"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                  max="100"
                />
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="order" class="text-sm font-medium">
                  Order By <span class="text-red-400">*</span>
                </label>
                <input
                  id="order"
                  type="number"
                  v-model="currentQuizData.lesson_order"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <div
                v-for="(form, index) in currentQuizData.questions"
                :key="index"
                class="w-full mt-3 bg-gray-200 rounded-lg p-4"
              >
                <div class="flex flex-col gap-5">
                  <div
                    class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full"
                  >
                    <label class="text-lg text-white"
                      >Question {{ index + 1 }}:</label
                    >
                    <button
                      v-if="form.id"
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="
                        (popupwindowquestiondelete = form.id),
                          (titlepass = form.question_text)
                      "
                    >
                      Remove Question
                    </button>

                    <button
                      v-else
                      type="button"
                      class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                      @click="removeFormUpdate(index)"
                    >
                      Remove Question
                    </button>
                  </div>

                  <div class="px-4 sm:px-6 py-2">
                    <textarea
                      v-model="form.question_text"
                      rows="2"
                      required
                      class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                      placeholder="Enter your question"
                    >
                    </textarea>
                  </div>
                </div>

                <div class="flex items-center gap-2 px-4 sm:px-6 py-2">
                  <!-- <input
                    type="radio"
                    value="choice"
                    v-model="form.choice_type"
                  />
                  Choice Type

                  <div>
                    <input
                      type="radio"
                      value="truefalse"
                      v-model="form.choice_type"
                    />
                    True or False
                  </div>
                  <div>
                    <input
                      type="radio"
                      value="matchthefollowing"
                      v-model="form.choice_type"
                    />
                    Match the following
                  </div>

                  <input
                    type="radio"
                    value="shortdescription"
                    v-model="form.choice_type"
                  />
                  Short Answer
                  <input
                    type="radio"
                    value="description"
                    v-model="form.choice_type"
                  />
                  Long Answer -->
                </div>

                <!-- {{ form.choiceType }} -->

                <div
                  v-if="form.choice_type == 'choice'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <div
                    v-for="(address, addrIndex) in form.answers"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    >
                    <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    />
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <label class="text-sm">Is Answer</label>
                  </div>
                </div>

                <div
                  v-if="form.choice_type == 'matchthefollowing'"
                  class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
                >
                  <div>
                    <div
                      v-for="(address, addrIndex) in form.matchthefollowing"
                      :key="addrIndex"
                      class="flex flex-wrap items-center gap-3 py-2"
                    >
                      <input
                        type="text"
                        v-model="address.left_text"
                        class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                        placeholder="Enter Left Option"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <div
                      v-for="(address, addrIndex) in form.matchthefollowing"
                      :key="addrIndex"
                      class="flex flex-wrap items-center gap-3 py-2"
                    >
                      <input
                        type="text"
                        v-model="address.right_text"
                        class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                        placeholder="Enter Right Option"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="form.choice_type == 'truefalse'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <!-- {{ form.answers }} -->
                  <div
                    v-for="(address, addrIndex) in form.truefalse"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                    <label class="text-sm text-gray-700"> </label>
                    <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                    <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    />
                    <!-- right_text -->
                    <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                    <label class="text-sm"
                      ><span v-if="addrIndex == 0">True</span>
                      <span v-else>False</span></label
                    >
                  </div>
                </div>

                <div
                  v-if="form.choice_type == 'shortdescription'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="2"
                    v-model="form.shortAnswer.answer_text"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>
                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Add Mark"
                  />
                </div>

                <div
                  v-if="form.choice_type == 'description'"
                  class="py-3 flex flex-col gap-2 mt-1 px-6"
                >
                  <textarea
                    rows="10"
                    v-model="form.longAnswer.answer_text"
                    class="flex-1 border rounded-md p-2 text-sm"
                    placeholder="Enter your answer"
                    required
                  >
                  </textarea>

                  <input
                    type="number"
                    required
                    v-model="form.max_mark"
                    placeholder="Add Mark"
                    class="flex-1 border rounded-md p-2 text-sm"
                  />
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-4 mt-4">
              <button
                type="button"
                @click="addFormUpdateNew"
                class="bg-blues text-sm text-white rounded-md px-4 py-2"
              >
                Add Question
              </button>
            </div>

            <div class="flex justify-end items-center gap-3 pb-4 mt-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-hover cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-10 py-2"
              >
                Update
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
class FileUpload {
  constructor(input) {
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                            <i class="fa fa-file-o" aria-hidden="true"></i>
                        </div>
                        <div class="file-details">
                            <p class="filename"></p>
                            <small class="textbox"></small>
                            <div class="progress">
                                <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                                </div>
                            </div>
                        </div>`;
    document.getElementById("uploaded_files").innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(".filename").text(this.file.name);
    $(".textbox").text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(".progress-bar").css("width", percent + "%");
            $(".progress-bar").text(percent + "%");
          }
        });
        return xhr;
      },

      url: `${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
        $(".filename").text("");
        $(".textbox").text("");
        // $(".progress-bar").css("width", percent + "%");
        $(".progress-bar").text("");
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
          this.disable_update = false;
        } else {
          // upload complete
          $(".textbox").text(res.data);
          $(`#${append_id}`).val(res.existingPath);
          console.log(res, "resp::");
          this.disable_update = false;
          // alert(JSON.parse(res))
        }
      },
    });
  }
}

import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";

import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import { defineComponent } from "vue";
import { VueDraggableNext } from "vue-draggable-next";

export default {
  components: {
    QuillEditor,
    FlashMessage,
    ConfirmPopup,
    HodHeader,
    CoordinateHeader,
    Header,
    draggable: VueDraggableNext,
  },

  data() {
    return {
      contentType: "html",
      markdown: "# Hello",
      lessonInfo: "",
      lessonVal: "",
      TimeTableVal: "",
      TimeTablepopUp: false,
      popUp: false,
      popUpLesson: false,
      sectionInfo: "",
      popUpsection: false,
      sectionval: "",
      popUpsectionUpdate: false,
      messages: {
        text: "",
        type: "null",
      },
      popupsectionDelete: false,
      idpass: "",
      popuplessonDelete: false,
      titlepass: "",
      lesson_id: "",
      popupquiz: false,
      is_documentPopup: false,
      is_tablePopup: false,
      pageX: 0,
      pageY: 0,
      uploadDragoverTracking: false,
      uploadDragoverEvent: false,
      documentList: "",
      timeTable: "",
      timeTable_val: "",
      popupDocumentDelete: false,
      selectUnitId: null,
      activeOperationMenu: null,
      activeLessonOperationMenu: null,
      description: "",
      descriptionUpdate: "",
      takeTab: "add_lesson",

      forms: [
        {
          question_text: "",
          choice_type: "choice",
          answers: [
            { answer_text: "", is_correct: false },
            { answer_text: "", is_correct: false },
            // { answer_text: "", is_correct: false },
            // { answer_text: "", is_correct: false },
          ],
          truefalse: [
            { answer_text: "True", is_correct: false },
            { answer_text: "False", is_correct: false },
          ],
          matchthefollowing: [
            { left_text: "", right_text: "" },
            { left_text: "", right_text: "" },
            // { left_text: "", right_text: "" },
            // { left_text: "", right_text: "" },
          ],
          shortAnswerMark: "",
          longAnswerMark: "",
          max_mark: "",
          // shortAnswer: "",
          // longAnswer: "",
        },
      ],
      choiceType: "choice",
      popUpQuiz: false,
      currentQuizData: "",
      popUpupdateQuiz: false,
      loaders: false,
      disable_submit: false,
      disable_update: false,
      popupwindowquestiondelete: null,
      loading: true,
      checkedAttempt: false,
      check_polls: false,
      poll_choice: [
        {
          text: "",
        },
        {
          text: "",
        },
      ],
      polls_data: {
        question: "",
        options: [{ text: "" }, { text: "" }],
      },
      video_error: "",
      pdf_error: "",
      audio_error: "",
      chunkSize: 1024 * 1024,
      chunkIndex: 0,
      totalChunks: 0,
      file: null,
      title: "Sample Video",
      activeCourseMenu: null,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
    lessonsBySection() {
      if (!this.lessonInfo || !this.lessonInfo.results) return {};
      return this.lessonInfo.results.reduce((acc, lesson) => {
        if (!acc[lesson.section_id]) acc[lesson.section_id] = [];
        acc[lesson.section_id].push(lesson);
        return acc;
      }, {});
    },
  },

  props: ["course_id", "semester", "batch"],

  async created() {
    this.lessoninfoGet();
    this.sectionInfoGet();
  },

  mounted() {
    // setTimeout(()=>{
    //     document.getElementById("getVideoU").value = this.lessonVal.video_url;
    // },300)

    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    script.onload = () => {
      console.log("jQuery loaded");
      this.initJQuery();
    };
    document.head.appendChild(script);
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    courseSectionToggle(id) {
      this.activeCourseMenu = this.activeCourseMenu === id ? null : id;
    },
    uploadFilebyChunkNew(file_id, append_id) {
      const fileInput = document.getElementById(`${file_id}`);
      const file = fileInput.files[0];
      if (!file) {
        alert("Please select a file.");
        return;
      }
      this.file = file;
      this.totalChunks = Math.ceil(file.size / this.chunkSize);
      this.chunkIndex = 0;
      this.sendChunk(append_id);
      console.log(append_id, "append_id::1");
    },

    sendChunk(append_id) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(this.file.size, start + this.chunkSize);
      const chunk = this.file.slice(start, end);

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", this.file.name);
      formData.append("chunkIndex", this.chunkIndex);
      formData.append("totalChunks", this.totalChunks);
      formData.append("title", this.title);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.VUE_APP_API}/video_uploader/chunk/`,
        true
      );
      // xhr.setRequestHeader("X-CSRFToken", getCSRFToken());

      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          document.getElementById("statusCode").innerText = response.message;
          if (response.video_url) {
            const fullUrl = response.video_url;
            // console.log(fullUrl, "::fullUrl::");
            // document.getElementById("videoPath").innerHTML =
            //   `Video URL: <a href="${fullUrl}" target="_blank">${fullUrl}</a>`;
            // let url =
            // if(document.getElementById(`${append_id}`)){
            // console.log(document.getElementById(`${append_id}`));
            console.log(append_id, "append_id::1");
            document.getElementById(`${append_id}`).value = `${fullUrl}`;
            // document.getElementById("videoUrlNew").value = `${fullUrl}`;
            // document.getElementById("getVideoU").value = `${fullUrl}`;

            // if(file_id == "fileupload"){
            //   // videoUrlNew
            //     document.getElementById("videoUrlNew").value = `${fullUrl}`;
            // }
            // else{
            //   document.getElementById("getVideoU").value = `${fullUrl}`;
            // }
            // }
            // console.log(url, "::url::");
          }

          this.chunkIndex++;
          if (this.chunkIndex < this.totalChunks) {
            this.sendChunk(append_id);
          } else {
            alert("Upload complete!");
          }
        } else {
          alert("Upload failed: " + xhr.responseText);
        }
      };

      xhr.send(formData);
    },

    addMoreChoiceType(index) {
      this.forms[index].answers.push({ answer_text: "", is_correct: false });
    },

    removeChoiceType(index) {
      if (this.forms[index].answers.length >= 3) {
        this.forms[index].answers.splice(index, 1);
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    addMoreMatchtheFollowing(index) {
      this.forms[index].matchthefollowing.push({
        left_text: "",
        right_text: "",
      });
    },

    removeMatchtheFollowing(index) {
      if (this.forms[index].matchthefollowing.length >= 3) {
        this.forms[index].matchthefollowing.splice(index, 1);
        // this.polls_data.splice(index, 1);
      } else {
        alert("Should 2 following on match the following.");
      }
    },

    CheckAudioSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 30 * 1024 * 1024;
      if (file.size > maxSize) {
        this.audio_error =
          "Audio file is larger than 30MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.audio_error = "";
        }, 5000);
      } else {
        this.audio_error = "";
      }
    },

    CheckPdfSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 30 * 1024 * 1024;
      if (file.size > maxSize) {
        this.pdf_error =
          "Pdf file is larger than 30MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.pdf_error = "";
        }, 5000);
      } else {
        this.pdf_error = "";
      }
    },

    CheckVideoSizeUpload(event) {
      const file = event.target.files[0];
      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        this.video_error =
          "Video file is larger than 500MB. Please choose a smaller file.";
        event.target.value = "";
        setTimeout(() => {
          this.video_error = "";
        }, 5000);
      } else {
        this.video_error = "";
      }
    },

    havePolls(id) {
      if (document.getElementById(id).checked) {
        this.check_polls = true;
      } else {
        this.check_polls = false;
      }
    },
    addRow() {
      this.polls_data.options.push({ text: "" });
    },
    removeRow(index) {
      if (this.polls_data.length > 1) {
        this.polls_data.splice(index, 1);
      }
    },
    // edit options in lesson
    editAddRow(poll) {
      console.log("poll", poll.length);
      return poll.push({ text: "", id: poll.length + 1, count: 0 });
    },
    editRemoveRow(poll, index) {
      console.log("poll", poll);
      if (poll.length > 1) {
        poll.splice(index, 1);
      }
    },

    haveAttempt(id) {
      if (document.getElementById(id).checked) {
        this.checkedAttempt = true;
      } else {
        this.checkedAttempt = false;
      }
    },
    removeQuestion(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequiz/question/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response) {
            // this.generalquiz = [];
            this.messages = {
              text: "Quiz Deleted successfully",
              type: "success",
            };
            // this.quizgetinfo();
            // this.popupwindow = false;
            this.lessoninfoGet();
            this.popUpupdateQuiz = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            // this.$router.go(0);
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: " ",
              type: "null",
            };
          }, 2000);
        });
    },

    // this.currentQuizData.questions.forEach((element) => {})

    updateQuizOfSection(value_id) {
      this.disable_submit = true;
      console.log("this.currentQuizData", this.currentQuizData);
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`,
          this.currentQuizData
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == "200") {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.lessoninfoGet();
              this.popUpupdateQuiz = false;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            // console.log("something went wrong");
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.lessoninfoGet();
              // this.popUpupdateQuiz = false;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    getupdateValues(value_id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.currentQuizData = response.data.data;
          } else {
            console.log("something went wrong");
          }
        });
    },

    updateVale(value) {
      setTimeout(() => {
        document.getElementById("getVideoU").value = value.video_url;
      }, 50);
    },

    triggerAddUNitClose() {
      this.$emit("close-AddUnit");
    },

    addForm() {
      this.forms.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
          // { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
          // { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: "",
        // shortAnswerMark: "",
        // longAnswerMark:"",
      });
    },

    addFormUpdateNew() {
      this.currentQuizData.questions.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: 0,
        // shortAnswerMark: "",
        // longAnswerMark:"",
      });
    },

    removeForm(index) {
      if (this.forms.length > 1) {
        this.forms.splice(index, 1);
      } else {
        alert("At least one form must be present!");
      }
    },

    removeFormUpdate(index) {
      this.currentQuizData.questions.splice(index, 1);
      // if (this.forms.length > 1) {
      //   this.forms.splice(index, 1);
      // } else {
      //   alert("At least one form must be present!");
      // }
    },

    convertToEmbed(id) {
      // console.log("video embed convert:::");
      let urlsBody = document.getElementById(id);
      let urls = document.getElementById(id).value;

      const videoId = this.extractVideoId(urls);

      if (videoId != null) {
        // this.embedLink = `https://www.youtube.com/embed/${videoId}`;
        // return `https://www.youtube.com/embed/${videoId}`
        urlsBody.value = `${videoId}`;
      } else {
        urlsBody.value = urls;
        // alert('Invalid YouTube URL');
      }
    },

    extractVideoId(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11
        ? `https://www.youtube.com/embed/${match[2]}`
        : null;

      // return (match && match[2].length === 11)
      // ? match[2]
      // : null;
    },

    videoUploadURL() {
      // this.disable_update = true;
      var uploader = new FileUpload(document.querySelector("#fileupload"));
      console.log(document.querySelector("#fileupload"));
      uploader.upload("videoUrl");
    },
    // videoUploadURL() {
    //   const lesson_vid = document.querySelector("#fileupload");
    //   const file = lesson_vid.files[0];

    //   if (!file) {
    //     console.error("No file selected");
    //     return;
    //   }

    //   const formData = new FormData();
    //   formData.append("file", file);

    //   axios
    //     .post(
    //       `${process.env.VUE_APP_API}/video_uploader/chunk/?Key=${this.userInfo.token_key}`,
    //       formData,
    //       {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //         },
    //       }
    //     )
    //     .then((resp) => {
    //       console.log("Upload response:", resp);
    //     })
    //     .catch((err) => {
    //       console.error("Upload error:", err.response?.data || err.message);
    //     });
    // },

    videoUploadURLUpdate() {
      // fileuploadUpdate
      var uploader = new FileUpload(
        document.querySelector("#fileuploadUpdate")
      );
      console.log(document.querySelector("#fileuploadUpdate"));
      uploader.upload("getVideoU");
    },

    initJQuery() {
      $(document).ready(() => {
        console.log("jQuery is ready in this component");
      });
    },

    addLessonOperation(id) {
      this.activeOperationMenu = null;
      if (this.activeLessonOperationMenu == id) {
        this.activeLessonOperationMenu = null;
      } else {
        this.activeLessonOperationMenu = id;
      }
    },
    addOperation(id) {
      this.activeLessonOperationMenu = null;
      if (this.activeOperationMenu == id) {
        this.activeOperationMenu = null;
      } else {
        this.activeOperationMenu = id;
      }
    },

    async lessoninfoGet() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/lessons/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (Object.keys(response.data) == "error") {
            this.lessonInfo = null;
          } else {
            this.lessonInfo = response.data;
            // this.descriptionUpdate = response.data;
          }
        });
    },

    async sectionInfoGet() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.status == 200) {
            this.sectionInfo = response.data;
            if (this.sectionInfo.data.length > 0) {
              this.activeCourseMenu = this.sectionInfo.data[0].id;
            }
            this.loading = false;
          } else {
            console.log("catch error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async updateLesson(el) {
      this.disable_submit = true;
      let urls = `${process.env.VUE_APP_API}/lesson_file_update/${this.lessonVal.id}/?Key=${this.userInfo.token_key}`;

      this.descriptionUpdate = document.querySelector(".ql-editor").innerHTML;
      console.log(this.descriptionUpdate);

      let HeaderVal = new FormData();
      console.log("HeaderVal::", HeaderVal);

      let audio_val = el.target.elements.audiofile.files;

      let file_val = el.target.elements.pdf_files.files;

      if (file_val.length > 0 || audio_val.length > 0) {
        if (file_val.length > 0) {
          HeaderVal.append("pdf_file", el.target.elements.pdf_files.files[0]);
        }
        if (audio_val.length > 0) {
          HeaderVal.append("audio_file", el.target.elements.audiofile.files[0]);
        }
        await axios
          .put(urls, HeaderVal, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((r) => {
            console.log(r);
            this.disable_submit = false;
            if (r.data.status == 200) {
              this.messages = {
                text: "lesson updated successfully",
                type: "success",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "",
                };
                this.popUp = false;
                // this.disable_submit = true;
              }, 2000);
            } else {
              this.messages = {
                text: r.data.message,
                type: "error",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "",
                };
                this.popUp = false;
                // this.disable_submit = true;
              }, 2000);
            }
          });
      } else {
        let token_key = this.userInfo.token_key;
        let infoDetails = {
          id: this.lessonVal.id,
          title: this.lessonVal.title,
          duration: this.lessonVal.duration,
          video_url: document.getElementById("getVideoU").value,
          status: this.lessonVal.status,
          created_at: this.lessonVal.created_at,
          updated_at: new Date(),
          content: this.descriptionUpdate,
          keyworeds: this.lessonVal.keyworeds,
          slug: this.lessonVal.slug,
          section_id: this.lessonVal.section_id,
          course_name: this.lessonVal.course_name,
          orderby: this.lessonVal.orderby,
          // showing_timer: this.lessonVal.showing_timer,
          file_type: document.getElementById("icon").value,
          polls: this.lessonVal.polls,
          show_polls: this.lessonVal.show_polls,
          // poll_details: {
          //   question: this.lessonVal.poll_details.question,
          //   options: this.lessonVal.poll_details.options,
          // },
        };
        // console.log("HeaderVal::", infoDetails);

        if (this.lessonVal.poll_details != null) {
          if (this.lessonVal.poll_details) {
            infoDetails["poll_details"] = {
              question: this.lessonVal.poll_details.question,
              options: this.lessonVal.poll_details.options,
            };
          }
        } else {
          infoDetails["poll_details"] = this.polls_data;
        }

        await axios
          .put(
            `${process.env.VUE_APP_API}/lessonupdate/${this.lessonVal.id}/?Key=${token_key}`,
            infoDetails
          )
          .then((response) => {
            this.disable_submit = false;
            if (response.data.message == "lesson updated successfully") {
              this.messages = {
                text: "lesson updated successfully",
                type: "success",
              };
              const fileInput = document.getElementById("fileuploadUpdate");
              if (fileInput) {
                fileInput.value = null;
              }
              setTimeout(() => {
                this.popUp = false;
                this.messages = {
                  text: "",
                  type: "",
                };
              }, 2000);
              // this.descriptionUpdate = "";
            } else {
              this.messages = {
                text: "Event Faild",
                type: "error",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "",
                };
              }, 2000);
            }
          });
      }

      await this.lessoninfoGet();

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    async createNewLesson(el) {
      this.disable_submit = true;
      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      let urls = `${process.env.VUE_APP_API}/lessonsnew/?Key=${this.userInfo.token_key}`;
      let HeaderVal = new FormData();
      let couseId = this.course_id;
      let file_val = el.target.elements.pdffile.files;
      let audio_file = el.target.elements.audio_file.files;
      if (file_val.length > 0) {
        HeaderVal.append("pdf_file", el.target.elements.pdffile.files[0]);
      }
      if (audio_file.length > 0) {
        HeaderVal.append("audio_file", el.target.elements.audio_file.files[0]);
      }
      HeaderVal.append("title", el.target.elements.title.value);
      HeaderVal.append("duration", el.target.elements.duration.value);
      HeaderVal.append("video_url", el.target.elements.videoUrlNew.value);
      HeaderVal.append("status", true);
      HeaderVal.append("content", this.description);
      HeaderVal.append("keyworeds", el.target.elements.keywords.value);
      HeaderVal.append("section_id", this.selectUnitId);
      HeaderVal.append("course_name", couseId);
      HeaderVal.append("orderby", el.target.elements.orderby.value);
      HeaderVal.append("file_type", el.target.elements.icon.value);
      HeaderVal.append("lesson_or_quiz", "lesson");
      HeaderVal.append("show_polls", el.target.elements.show_polls.checked);
      HeaderVal.append("polls", el.target.elements.poll_attempt.checked);
      HeaderVal.append("polls_data", JSON.stringify(this.polls_data));

      // HeaderVal.append("showing_timer", el.target.elements.showing_timer.value);

      // HeaderVal.append("quizzes", 2);

      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Lesson added successfully",
              type: "success",
            };
            const fileInput = document.getElementById("fileupload");
            if (fileInput) {
              fileInput.value = null;
            }
            this.$refs.lessonaddFnadd.reset();
            this.popUpLesson = false;
            this.disable_submit = false;
            this.lessoninfoGet();
            this.description = "";
            this.polls_data = {
              question: "",
              options: [{ text: "" }, { text: "" }],
            };
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            this.disable_submit = false;
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    async createQuizOfSection(el) {
      this.disable_submit = true;
      // this.description = document.querySelector(".ql-editor").innerHTML;
      // console.log(this.description);

      let urls = `${process.env.VUE_APP_API}/lessonsnew/?Key=${this.userInfo.token_key}`;

      let HeaderVal = {};
      let couseId = this.course_id;

      HeaderVal["title"] = el.target.elements.title.value;
      HeaderVal["content"] = el.target.elements.content.value;
      HeaderVal["section_id"] = this.selectUnitId;
      HeaderVal["course_name"] = parseInt(couseId);
      HeaderVal["orderby"] = el.target.elements.order.value;
      HeaderVal["lesson_or_quiz"] = "quiz";

      let quizData = {};
      quizData["user"] = this.userInfo.user.id;
      quizData["course"] = parseInt(couseId);
      quizData["name"] = el.target.elements.title.value;
      quizData["description"] = "description";

      quizData["total_score"] = 100;
      quizData["qualify_certificate"] = true;
      quizData["min_score"] = 50;
      quizData["pre_quiz"] = false;

      quizData["question_attempt"] =
        el.target.elements.question_attempt.checked;
      if (this.checkedAttempt) {
        quizData["question_attempt_count"] = parseInt(
          el.target.elements.question_attempt_count.value
        );
      }

      quizData["questions"] = this.forms;
      HeaderVal["quiz"] = quizData;

      await axios.post(urls, HeaderVal).then((response) => {
        console.log(response);
        this.disable_submit = false;
        if (response.data.status == 200) {
          this.messages = {
            text: "Quiz added successfully",
            type: "success",
          };
          this.$refs.addQuizRefs.reset();
          this.popUpQuiz = false;
          this.checkedAttempt = false;
          // this.disable_submit = true;
          this.lessoninfoGet();
          this.forms = [
            {
              question_text: "",
              choice_type: "choice",
              answers: [
                { answer_text: "", is_correct: false },
                { answer_text: "", is_correct: false },
                // { answer_text: "", is_correct: false },
                // { answer_text: "", is_correct: false },
              ],
              truefalse: [
                { answer_text: "True", is_correct: false },
                { answer_text: "False", is_correct: false },
              ],
              matchthefollowing: [
                { left_text: "", right_text: "" },
                { left_text: "", right_text: "" },
                // { left_text: "", right_text: "" },
                // { left_text: "", right_text: "" },
              ],
              shortAnswerMark: "",
              longAnswerMark: "",
              max_mark: "",
            },
          ];
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };
          this.disable_submit = false;
        }
      });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },

    async createNewsection(el) {
      this.disable_submit = true;
      let newsection = {
        duration: el.target.elements.duration.value,
        // rbt_levels: el.target.elements.rbt_levels.value,
        title: el.target.elements.title.value,
        course_id: this.course_id,
        file_type: el.target.elements.icon.value,
      };
      await axios
        .post(
          `${process.env.VUE_APP_API}/sectionnew/?Key=${this.userInfo.token_key}`,
          newsection
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Section added successfully",
              type: "success",
            };
            this.$refs.addSection.reset();
            this.popUpsection = false;
            this.sectionInfoGet();
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
      // setTimeout(()=>{this.$router.go(0);},1000)
    },
    updatesection(data) {
      this.disable_submit = true;
      this.popUpsectionUpdate = false;

      let updatedsection = {
        id: data.id,
        title: data.title,
        course_name: data.course_name,
        file_type: data.file_type,
      };
      console.log("updatedsection", updatedsection);

      axios
        .put(
          `${process.env.VUE_APP_API}/Sectionupdate/${data.id}/?Key=${this.userInfo.token_key}`,
          updatedsection
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "section updated successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    async deleteLesson(lessonVal) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/lesson_deleted/${lessonVal}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          //  setTimeout(()=>{this.$router.go(0);},1000)
          if (response.data.status == 200) {
            this.messages = {
              text: "lesson Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);

      this.popuplessonDelete = false;
      await this.lessoninfoGet();
    },
    async deleteSection(section) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/section_deleted/${section}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == 200) {
            this.messages = {
              text: "Section Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);

      this.popupsectionDelete = false;
      await this.sectionInfoGet();
      //  setTimeout(()=>{this.$router.go(0);},1000)
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.activeOperationMenu = null;
        this.activeLessonOperationMenu = null;
      }
    },
    async onReorder(sectionId, evt) {
      console.log("Drag change:", evt, "Target Section:", sectionId);
      const token_key = this.userInfo.token_key;
      // When lesson is added to a new section
      if (evt.added) {
        const movedLesson = evt.added.element;
        movedLesson.section_id = sectionId; // update section
        console.log(`Lesson ${movedLesson.id} moved to section ${sectionId}`);
      }
      // Get all lessons in this section
      const lessons = this.lessonsBySection[sectionId] || [];
      // Reassign order numbers
      lessons.forEach((lesson, index) => {
        lesson.orderby = index + 1;
      });
      // Push updates to API
      for (let lesson of lessons) {
        const infoDetails = {
          orderby: lesson.orderby,
          section_id: lesson.section_id,
        };
        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/lesson-unit-order-id-updated/${lesson.id}/?Key=${token_key}`,
            infoDetails
          );
          console.log(`Updated lesson ${lesson.id}:`, response.data);
        } catch (err) {
          console.error(`Error updating lesson ${lesson.id}:`, err);
        }
      }
      this.messages = { text: "Lesson order updated", type: "success" };
      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

/* loader  */
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #ada7a7;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
